import { prioritizeAndMapDropdownItems } from '@approvalmax/ui';
import { useSelector } from 'modules/react-redux';
import { WarningLevel } from 'modules/request';
import { memo, useMemo } from 'react';
import { getContactDisplayNameByIntegrationCode } from 'shared/helpers';

import { getQBooksContext } from '../../../../../selectors/qbooks';
import { useOcrLinesItems, useRequestExpanded } from '../../hooks';
import { GeneralSelector } from '../GeneralSelector/GeneralSelector';
import { NestedMenuItem } from '../NestedMenuItem/NestedMenuItem';
import { messages } from './AccountCell.messages';
import { AccountCellProps } from './AccountCell.types';

export const AccountCell = memo<AccountCellProps>((props) => {
    const { cellProps, name, ...otherProps } = props;

    const request = useRequestExpanded();
    const context = useSelector(getQBooksContext);
    const sortedOcrLineItems = useOcrLinesItems();

    const { index } = cellProps.item;

    const items = useMemo(() => {
        return sortedOcrLineItems
            ? prioritizeAndMapDropdownItems(context.accounts, sortedOcrLineItems[index]?.accountIds)
            : context.accounts;
    }, [context.accounts, index, sortedOcrLineItems]);

    const showWarning = sortedOcrLineItems ? (sortedOcrLineItems[index]?.accountIds || []).length > 1 : false;

    return (
        <GeneralSelector
            {...otherProps}
            name={name}
            items={items}
            cellProps={cellProps}
            warningLevel={showWarning ? WarningLevel.Yellow : WarningLevel.None}
            warningMessage={
                showWarning
                    ? messages.warning({
                          contactDisplayName: getContactDisplayNameByIntegrationCode(request.integrationCode),
                      })
                    : undefined
            }
            customMenuItem={({ key, ...item }) => (
                <NestedMenuItem key={key} {...item} nestingLevel={item.nestingLevel} />
            )}
        />
    );
});

AccountCell.displayName = 'AccountCell';
